// extracted by mini-css-extract-plugin
export default {"brandPromo":"zF-z","carousel":"AF-z"};